// MyTeam.tsx
import React, { useContext, useState } from "react";
import CreateTeamForm from "./components/CreateTeamForm";
import JoinTeamForm from "./components/JoinTeamForm";
import { AuthContext } from "../../AuthContext";
import { UserContext } from "../../UserContext";
import { InfoContext } from "../../InfoContext";
import { DashboardContext } from "../DashboardContext";
import LoadingCircle from "../../LoadingCircle";
import TeamManageCard from "./components/TeamManageCard";
import TeamInfoCard from "../../TeamInfoCard";
import { useAlert } from "../../AlertContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import AdminTeamPage from "./AdminTeamPage";

const server_url = process.env.REACT_APP_BACKEND_URL;

const MyTeam: React.FC = () => {
  const { role, session, setSession } = useContext(AuthContext);
  const { user } = useContext(UserContext);
  const { loading, myTeam, handleWithdraw } = useContext(DashboardContext);
  const { getTeamById } = useContext(InfoContext);
  const [isRegistering, setIsRegistering] = useState(false);

  const { showAlert } = useAlert();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="flex flex-col justify-center items-center py-10 w-full h-full text-white">
        <LoadingCircle />
      </div>
    );
  }

  if (role === "ADMIN") {
    console.log("Admin role detected");
    return <AdminTeamPage />;
  }

  if (role === "CAPTAIN" || role === "CAPTAIN_PENDING") {
    if (myTeam) {
      return (
        <div className="flex flex-col justify-start items-center py-6 px-3 gap-y-6 w-full h-full text-white overflow-y-auto mt-16">
          <h2 className="text-2xl font-bold mb-4">My Team</h2>
          <div className="w-full max-w-3xl">
            <TeamManageCard myTeam={myTeam} />
          </div>
        </div>
      );
    }
  }

  if (role === "USER") {
    return (
      <div className="flex flex-col justify-start items-center py-6 px-3 gap-y-6 w-full h-full overflow-y-auto mt-16">
        {user?.member_of && (
          <div className="max-w-md my-4 p-6 bg-white rounded-lg shadow-md w-full">
            <h2 className="text-2xl font-bold mb-2">Join Requests</h2>
            <h3 className="text-zinc-700 mb-6">
              You already sent a request to team{" "}
              <span className="font-bold">
                {getTeamById(user?.member_of)?.name}
              </span>
              ! Please wait until the Captain accepts you. You can still
              withdraw your request, change the Team or create your own team
              below!
            </h3>
            <button
              onClick={handleWithdraw}
              className="px-4 py-2 bg-red-500 text-white rounded-xl hover:bg-red-600"
            >
              Withdraw
            </button>
          </div>
        )}
        <div className="relative flex w-64 bg-white/10 p-1 rounded-xl ">
          <div
            className={`absolute top-0 left-0 h-full w-1/2 bg-white/20 rounded-xl transition-transform duration-300 ease-in-out ${
              !isRegistering ? "translate-x-0" : "translate-x-full"
            }`}
          />
          <button
            onClick={() => setIsRegistering(false)}
            className={`relative z-10 flex-1 py-2 text-center font-medium ${
              !isRegistering ? "text-white" : "text-gray-400"
            }`}
          >
            Join Team
          </button>

          <button
            onClick={() => setIsRegistering(true)}
            className={`relative z-10 flex-1 py-2 text-center font-medium ${
              isRegistering ? "text-white" : "text-gray-400"
            }`}
          >
            Create Team
          </button>
        </div>
        {isRegistering ? <CreateTeamForm /> : <JoinTeamForm />}
      </div>
    );
  }
  if (role === "PLAYER") {
    const team =
      user?.member_of !== undefined && user?.member_of !== null
        ? getTeamById(user.member_of)
        : undefined;

    if (!team) {
      return <h2 className="text-2xl mb-4">My Team</h2>;
    }

    const handleLeaveTeam = async () => {
      if (window.confirm("Are you sure you want to leave this team?")) {
        try {
          const response = await axios.post(`${server_url}/leaveTeam`, {
            access_token: session.access_token,
          });
          if (response.data.status) {
            showAlert(
              "success",
              "Successfully left Team. Please log in again!"
            );
            setSession(null);
            navigate("/login");
          } else {
            showAlert("error", "Error when leaving Team, try again!");
          }
        } catch (error) {
          showAlert("error", "Error when leaving Team, try again!");
        }
      }
    };

    return (
      <div className="flex flex-col justify-start items-center py-10 w-full h-full text-white mt-16">
        <h2 className="text-2xl mb-4">My Team</h2>
        <TeamInfoCard team={team} />
        <div className="flex p-4 justify-end w-auto">
          <button
            onClick={handleLeaveTeam}
            className="flex-1 py-2 px-4 rounded-xl bg-red-500 text-white hover:bg-red-600"
          >
            Leave Team
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col justify-center items-center py-10 w-full h-full text-white bg-gradient-to-r from-blue-750 to-blue-850">
      <div className="flex flex-col justify-start items-center py-10 w-full h-full text-white">
        <p>My Team</p>
      </div>
    </div>
  );
};

export default MyTeam;
